<template>
  <MenuHeader />
  <MenuBody />
  <MenuFooter />
</template>

<script>
import MenuHeader from '../molecules/MenuHeader.vue'
import MenuBody from '../molecules/MenuBody.vue'
import MenuFooter from '../molecules/MenuFooter.vue'

export default {
  name: 'MenuView',
  components: {
    MenuHeader,
    MenuBody,
    MenuFooter,
  }
}
</script>
